module.exports = __webpack_public_path__ + "img/623.0aca9161.jpg";